import { uniqBy } from 'lodash-es';
import type { Custodian } from 'models/custodian';
import type { DealSplitData } from 'models/forms/DealSplitData';
import type { FieldFormatter, FieldValueValidator } from 'models/forms/fields/utils';
import { isHandledBySamePredicate } from 'models/forms/fields/utils';

import type { FieldMetadataBase } from './FieldMetadataBase';

export type DealSplitGridData = DealSplitData[];

export type DealSplitGridMetadata = FieldMetadataBase<'DealSplitGrid', DealSplitGridData> & {
  availableCustodians: Custodian[];
  notionalToSplit: number;
  currency: string;
};

export function isDealSplitGridMetadata(val: unknown): val is DealSplitGridMetadata {
  return (val as DealSplitGridMetadata).type === 'DealSplitGrid';
}

export function mergeDealSplitGridMetadataField(
  firstField: DealSplitGridMetadata,
  secondField: DealSplitGridMetadata,
): DealSplitGridMetadata {
  return {
    ...firstField,
    availableCustodians: uniqBy(
      [...firstField.availableCustodians, ...secondField.availableCustodians],
      custodian => custodian.id,
    ),
  };
}

export const dealSplitGridMetadataFormatter: FieldFormatter<DealSplitGridMetadata> = {
  areSameType: isHandledBySamePredicate(isDealSplitGridMetadata),
  merge: mergeDealSplitGridMetadataField,
  isHandled: isDealSplitGridMetadata,
  withDefault: f => ({ ...f, availableCustodians: [{ id: '', label: '', eliotCode: '' }, ...f.availableCustodians] }),
};

export const dealSplitGridMetadataValueValidator: FieldValueValidator<DealSplitGridMetadata, Custodian> = {
  isHandled: isDealSplitGridMetadata,
  validateValue: (value, field) => field.availableCustodians.some(c => c.id === value.id),
};
